export const operatorTypes = ['AND', 'OR', 'TRUE', 'FALSE'];
//# sourceMappingURL=types.js.map